import {CustomerProjectState} from "../store/customer_project_state";
import {Reducer} from "redux";
import {
    CustomerProjectAction,
    CustomerProjectActionType,
    ICallbackGetProjectAction,
    ICallbackGetEntryProjectsAction,
} from "../action/customer_project_action";

const initialState: CustomerProjectState = {
    project: null,
    company: null,
    entryProjects: [],
    isLoading: false
};

const customerProjectReducer: Reducer<CustomerProjectState> = (state = initialState, action: CustomerProjectAction): CustomerProjectState => {
    switch (action.type) {

        case CustomerProjectActionType.REQUEST_GET_PROJECT: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerProjectActionType.CALLBACK_GET_PROJECT: {
            const _action = action as ICallbackGetProjectAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    project: _action.item ? _action.item.project : null,
                    company: _action.item ? _action.item.company : null,
                    entryProjects: _action.item ? _action.item.entryProjects : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case CustomerProjectActionType.REQUEST_GET_ENTRY_PROJECTS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerProjectActionType.CALLBACK_GET_ENTRY_PROJECTS: {
            const _action = action as ICallbackGetEntryProjectsAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    entryProjects: _action.item ? _action.item.entryProjects : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case CustomerProjectActionType.REQUEST_CREATE_ENTRY: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerProjectActionType.CALLBACK_CREATE_ENTRY: {
            // const _action = action as ICallbackCreateEntryAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case CustomerProjectActionType.REQUEST_DELETE_ENTRY: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerProjectActionType.CALLBACK_DELETE_ENTRY: {
            // const _action = action as ICallbackDeleteEntryAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default customerProjectReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_project_reducer.ts